import { useFormik } from "formik";
import useParks from "../../../../hooks/api-calls/useParks";
import useHandleErrors from "../../../../hooks/useHandleErrors";
import { ClientService } from "../../../../services/client/clientService";
import { toast } from "sonner";
import { useEffect } from "react";
import { ActionIcon, Button, Modal, Text } from "rizzui";
import { IoClose } from "react-icons/io5";
import CustomSelect from "../../../../components/forms/CustomSelect";
import { Client } from "../../../../type/entities/client-type";


interface AddParksToClientsModalProps {
    isOpen: boolean;
    onClose: () => void;
    refetch: () => void;
    client: Client | null;
    parkHasClients: any;
}


const AddParksToClientsModal: React.FC<AddParksToClientsModalProps> = ({ isOpen, onClose, refetch, client, parkHasClients }) => {

    // STATES

    const service = new ClientService();
    
    // HOOKS

    const { handleErrors } = useHandleErrors();
    const { getParksList } = useParks();

    // FORMIK

    const formik = useFormik({
        initialValues: {
            id : '',
            parks: [],
        },
        validateOnBlur: false,
        onSubmit: values => {
            handleCreate(values)
        },
    })

    // FUNCTIONS

    //--------------------------------------------------------------------------------------------------------------
    /**
     * @ES AÑADIR PARQUES AL CLIENTE
     * @EN ADD PARKS TO CLIENT
     * 
     * @param values
     * @returns
     */
    //--------------------------------------------------------------------------------------------------------------
    const handleCreate = async (values: any) => {
        try {
            const response = (await (service.addParksToClient( values.id, values.parks ))).getResponseData();
            if(response.success) {
                refetch();
                onClose();
                toast.success('Parques añadidos al cliente correctamente');
            }
            else {
                toast.error('Error al añadir parques al cliente');
            }
        } catch (error) {
            handleErrors(error);
        }
    }
    //--------------------------------------------------------------------------------------------------------------


    // USE EFFECT

    useEffect(() => {
        if(client) {
            formik.setFieldValue('id', client.id);
            formik.setFieldValue('parks', parkHasClients.map((park: any) => park.park.id));
        }
    }
    , [client]);


    // RENDER

    return (
        <Modal 
            isOpen={isOpen}
            onClose={onClose}
            size='sm'
            overlayClassName='backdrop-blur'
            containerClassName='!max-w-xl !shadow-xl'
            className='z-[9999] [&_.pointer-events-none]:overflow-visible'
        >
            <div className="m-auto px-7 pt-6 pb-4">
                <div className="mb-7 flex items-center- justify-between">
                    <Text className="text-xl"> Añadir parques al cliente {client?.name} </Text>
                    <ActionIcon size="sm" variant="text" onClick={onClose}>
                        <IoClose className='h-auto w-6' strokeWidth={1.8} />
                    </ActionIcon>
                </div>

                <CustomSelect
                    id="parks"
                    label="Parques"
                    placeholder="Selecciona los parques"
                    isMulti
                    options={getParksList()}
                    isClearable
                    isSearchable
                    onChange={(selectedOptions: any) => {
                        const selectedValues = selectedOptions.map((option: any) => option.value);
                        formik.setFieldValue('parks', selectedValues);
                    }}
                    value={formik.values.parks.map((park: any) => {
                        const selectedPark = getParksList().find((option: any) => option.value === park);
                        return selectedPark ? selectedPark : { value: park.id, label: park.name };
                    })}
                    className="mb-4"
                />
            </div>

            <div className='flex justify-center p-7'>
                <Button
                    disabled={false}
                    onClick={() => formik.handleSubmit()}
                    color='primary'
                >
                    Añadir
                </Button>
            </div>  

        </Modal>

    )


}

export default AddParksToClientsModal;